<template>
  <div id="users" class="users">
    <div
      :id="'users_' + type"
      style="overflow-y: auto;"
      @scroll="onUserScroll"
      v-resize="onResizeUserList"
      :style="{ height: userListHeight + 'px' }"
    >
      <!-- v-resize="onResizeUserList"
      :style="{ height: userListHeight + 'px' }" -->
      <div :id="'users_' + type + '_wrapper'">
        <div :id="'users_' + type + '_container'">
          <v-layout justify-center column fill-height v-if="userloading || usersearching">
            <div class="text-xs-center mt-4 mb-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </v-layout>
          <template v-else-if="livechatUsers(type) && livechatUsers(type).length > 0">
            <div
              v-for="(user, index) in sortedUsers"
              :key="'user-' + index + '-' + user.userid || user.group_id"
              @click.stop="selectUser(user)"
              class="user"
            >
              <user-item
                v-model="livechatUsers(type)[index]"
                :selected="
                  selectedUser != null &&
                    (user.userid ? user.userid : user.group_id) ==
                      (selectedUser.userid ? selectedUser.userid : selectedUser.group_id)
                "
                :key="livechatUsers(type)[index].userid"
              ></user-item>

              <v-divider></v-divider>
            </div>
            <!-- <div
            v-if="loadmore"
            class="text-xs-center"
            style="background:#eee;padding-top:10px;padding-bottom:10px"
          >
            <v-progress-circular indeterminate color="grey" small class="mr-2" :width="2"></v-progress-circular>Loading
          </div>-->
            <template v-if="isMobile">
              <div
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
                @click="onLoadmore"
              >
                <template v-if="loadmore">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    small
                    class="mr-2"
                    :width="2"
                  ></v-progress-circular
                  >Loading
                </template>
                <template v-else @click="onLoadmore">Click to load more conversation</template>
              </div>
            </template>
            <template v-else>
              <div
                v-if="loadmore"
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              >
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </div>
            </template>
          </template>
          <v-layout justify-center column fill-height v-else>
            <div class="text-xs-center mt-4 mb-4">
              <img src="/static/img/assets/livechat/no_user.png" alt />
              <div>No users</div>
            </div>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userItem from './livechat-user-item'
import api from '@/api'
import { cloneDeep } from 'lodash'
import io from 'socket.io-client'
import dayjs from 'dayjs'
import config from '@/config'
import _ from 'lodash'

export default {
  props: [
    'value',
    'type',
    'app',
    'line_tab',
    'filter',
    'isMobile',
    'usersearching',
    'newchatnotify',
    'timestamp'
  ],
  data: function() {
    return {
      socket: null,
      loading: true,
      userloading: true,
      maxTime: 15000,
      timer: '',
      windowHeight: 0,
      userListHeight: 0,
      limit: 20,
      offset: 0,
      users: [],
      isAutoRefresh: true,
      vh: null
      // loadmore: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      livechatUsers: 'getLivechatUsers',
      selectedUser: 'getCurrentUser',
      isSearching: 'isLivechatSearching',
      searchlist: 'getLivechatSearching'
    }),
    sortedUsers: function() {
      var vm = this
      var users = []
      users = vm.livechatUsers(vm.type).sort(function(a, b) {
        return new Date(b.lastreply_time) - new Date(a.lastreply_time)
      })
      vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: users })
      return users
    },
    loadmore() {
      return this.$store.state.livechat.loadmore
    }
  },
  components: {
    'user-item': userItem
  },
  mounted: async function() {
    const vm = this
    this.vh = window.innerHeight * 0.01
    vm.userloading = true

    vm.socket = io(config.socketUrl, {
      transports: ['websocket']
    })

    vm.socket.on(`livechat:startconversation:${vm.$store.state.livechat.pageid}`, message => {
      if (vm.type === 'bot') {
        vm.$store.state.livechat.userlist[vm.type].users = vm.$store.state.livechat.userlist[
          vm.type
        ].users.filter(user =>
          user.group_id
            ? user.group_id !== message.user.group_id
            : user.userid !== message.user.userid
        )
      } else {
        if (message.user.app === 'line') {
          if (vm.$store.state.livechat.app === 'line') {
            if (vm.$store.state.livechat.line_tab === 'group' && message.user.group_id) {
              message.user.context = 'contactadmin'
              message.user.adminread = true
              vm.$store.state.livechat.userlist[vm.type].users = [message.user].concat(
                vm.$store.state.livechat.userlist[vm.type].users
              )
            } else if (vm.$store.state.livechat.line_tab === 'user' && !message.user.group_id) {
              message.user.context = 'contactadmin'
              message.user.adminread = true
              vm.$store.state.livechat.userlist[vm.type].users = [message.user].concat(
                vm.$store.state.livechat.userlist[vm.type].users
              )
            }
          }
        } else if (vm.$store.state.livechat.app !== 'line') {
          vm.$store.state.livechat.userlist[vm.type].users = [message.user].concat(
            vm.$store.state.livechat.userlist[vm.type].users
          )
        }
      }
    })
    vm.socket.on(`livechat:endconversation:${vm.$store.state.livechat.pageid}`, message => {
      if (vm.type === 'admin') {
        vm.$store.state.livechat.userlist[vm.type].users = vm.$store.state.livechat.userlist[
          vm.type
        ].users.filter(user =>
          user.group_id
            ? user.group_id !== message.user.group_id
            : user.userid !== message.user.userid
        )
      } else {
        if (message.user.app === 'line') {
          if (vm.$store.state.livechat.app === 'line') {
            if (vm.$store.state.livechat.line_tab === 'group' && message.user.group_id) {
              message.user.context = 'bot'
              message.user.adminread = true
              vm.$store.state.livechat.userlist[vm.type].users = [message.user].concat(
                vm.$store.state.livechat.userlist[vm.type].users
              )
            } else if (vm.$store.state.livechat.line_tab === 'user' && !message.user.group_id) {
              message.user.context = 'bot'
              message.user.adminread = true
              vm.$store.state.livechat.userlist[vm.type].users = [message.user].concat(
                vm.$store.state.livechat.userlist[vm.type].users
              )
            }
          }
        } else if (vm.$store.state.livechat.app !== 'line') {
          vm.$store.state.livechat.userlist[vm.type].users = [message.user].concat(
            vm.$store.state.livechat.userlist[vm.type].users
          )
        }
      }
    })

    vm.socket.on(`livechat:adminreadchat:${vm.$store.state.livechat.pageid}`, message => {
      const user = vm.$store.state.livechat.userlist[vm.type].users.filter(
        user => user.userid === message.userid
      )
      if (user.length > 0 && !user[0].adminread) {
        user[0].adminread = true
      }
      vm.$store.state.livechat.users_unread[message.userid] = 0

      if (
        vm.newchatnotify[
          `${message.app}_${message.type === 'group' ? 'group_' : ''}${
            message.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] > 0
      ) {
        vm.newchatnotify[
          `${message.app}_${message.type === 'group' ? 'group_' : ''}${
            message.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] =
          vm.newchatnotify[
            `${message.app}_${message.type === 'group' ? 'group_' : ''}${
              message.context === 'contactadmin' ? 'admin' : 'bot'
            }`
          ] - 1
      }
    })

    vm.socket.on(`livechat:adminunreadchat:${vm.$store.state.livechat.pageid}`, message => {
      const user = vm.$store.state.livechat.userlist[vm.type].users.filter(
        user =>
          (user.group_id && message.userid === user.group_id) || user.userid === message.userid
      )
      if (user.length > 0 && user[0].adminread) {
        user[0].adminread = false
      }
      vm.$store.state.livechat.users_unread[message.userid] = 1

      if (
        vm.newchatnotify[
          `${message.app}_${message.type === 'group' ? 'group_' : ''}${
            message.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] > -1
      ) {
        vm.newchatnotify[
          `${message.app}_${message.type === 'group' ? 'group_' : ''}${
            message.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] =
          vm.newchatnotify[
            `${message.app}_${message.type === 'group' ? 'group_' : ''}${
              message.context === 'contactadmin' ? 'admin' : 'bot'
            }`
          ] + 1
      }
    })

    vm.socket.on(`livechat:getuserthread:${vm.$store.state.livechat.pageid}`, message => {
      if (this.isSearching) {
        const userId = _(vm.$store.state.livechat.userlist[vm.type].users)
          .map('userid')
          .find(userId => message.userid === userId)

        if (!userId) {
          return // Skip when the message from the socket isn't included in the filtered users
        }
      }
      const user = vm.$store.state.livechat.userlist[vm.type].users.filter(user =>
        message.group_id ? user.group_id === message.group_id : user.userid === message.userid
      )
      if (typeof vm.$store.state.livechat.users_unread[message.userid] === 'undefined') {
        vm.$store.state.livechat.users_unread[message.userid] = 0
      }

      if (
        (user.length === 0 || (user && user[0] && user[0].adminread)) &&
        vm.$store.state.livechat.users_unread[message.userid || message.group_id] !== 1
      ) {
        vm.newchatnotify[
          `${message.app}_${message.group_id ? 'group_' : ''}${
            message.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] =
          vm.newchatnotify[
            `${message.app}_${message.group_id ? 'group_' : ''}${
              message.context === 'contactadmin' ? 'admin' : 'bot'
            }`
          ] + 1
        vm.$store.state.livechat.users_unread[message.userid || message.group_id] = 1
      } else if (!message.adminread && message.context !== message.prev_context) {
        vm.newchatnotify[
          `${message.app}_${message.group_id ? 'group_' : ''}${
            message.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] =
          vm.newchatnotify[
            `${message.app}_${message.group_id ? 'group_' : ''}${
              message.context === 'contactadmin' ? 'admin' : 'bot'
            }`
          ] + 1
        if (
          vm.newchatnotify[
            `${message.app}_${message.group_id ? 'group_' : ''}${
              message.context === 'contactadmin' ? 'bot' : 'admin'
            }`
          ] > 0
        ) {
          vm.newchatnotify[
            `${message.app}_${message.group_id ? 'group_' : ''}${
              message.context === 'contactadmin' ? 'bot' : 'admin'
            }`
          ] =
            vm.newchatnotify[
              `${message.app}_${message.group_id ? 'group_' : ''}${
                message.context === 'contactadmin' ? 'bot' : 'admin'
              }`
            ] - 1
        }
      }

      if (
        (vm.type === 'bot' && message.context === 'contactadmin') ||
        (vm.type === 'admin' && message.context === '')
      ) {
        vm.$store.state.livechat.userlist[vm.type].users = vm.$store.state.livechat.userlist[
          vm.type
        ].users.filter(user =>
          user.group_id ? user.group_id !== message.group_id : user.userid !== message.userid
        )
      } else {
        vm.$store.state.livechat.userlist[vm.type].users = vm.$store.state.livechat.userlist[
          vm.type
        ].users.filter(user =>
          user.group_id ? user.group_id !== message.group_id : user.userid !== message.userid
        )
        if (message.app === 'line') {
          if (vm.$store.state.livechat.app === 'line') {
            if (vm.$store.state.livechat.line_tab === 'group' && message.group_id) {
              vm.$store.state.livechat.userlist[vm.type].users = [message].concat(
                vm.$store.state.livechat.userlist[vm.type].users
              )
            } else if (vm.$store.state.livechat.line_tab === 'user' && !message.group_id) {
              vm.$store.state.livechat.userlist[vm.type].users = [message].concat(
                vm.$store.state.livechat.userlist[vm.type].users
              )
            }
          }
        } else if (vm.$store.state.livechat.app !== 'line') {
          if (message.app === vm.$store.state.livechat.app) {
            vm.$store.state.livechat.userlist[vm.type].users = [message].concat(
              vm.$store.state.livechat.userlist[vm.type].users
            )
          }
        }
      }
      if (document.getElementById('noti_sound') && !JSON.parse(localStorage.getItem('muteChat'))) {
        document.getElementById('noti_sound').volume = 1
        document.getElementById('noti_sound').play()
      }
    })
    vm.socket.on('connect', () => {
      let roomName = `pageid:${vm.$store.state.livechat.pageid}`
      if (vm.$store.state.SOCKET_GROUP_GT817.includes(vm.$store.state.livechat.pageid)) {
        roomName = 'gt817'
      }
      vm.socket.emit('join-room', roomName, async error => {
        if (error) {
          console.log(`join-room error`, error)
        }

        vm.$emit('livechatnotiunread')
        try {
          if (vm.$route.query.userid) {
            vm.$nextTick(() => {
              vm.$set(vm.$store.state.livechat, 'app', vm.$route.query.app)
              vm.$set(vm.$store.state.livechat, 'userid', vm.$route.query.userid)
            })
          } else {
            vm.$set(vm.$store.state.livechat, 'app', vm.app)
            vm.$set(vm.$store.state.livechat, 'userid', null)
          }
          if (vm.$route.query.pageid) {
            vm.$set(vm.$store.state.livechat, 'pageid', vm.$route.query.pageid)
          }
          await vm.$store.dispatch('loadLatestUsers', {
            type: vm.type
          })

          vm.userloading = false
          vm.usersearching = false
          vm.onResizeUserList()
        } catch (error) {
          console.error(error)
          vm.userloading = false
          vm.usersearching = false
          vm.$swal.fire({
            title: 'Load failed',
            type: 'error',
            confirmButtonText: vm.$t('Confirm')
          })
        }

        console.log('[socket connected]: ', vm.socket.connected)
      })
      vm.socket.on('disconnect', reason => {
        console.log('[socket disconnected]: ', reason)
      })
      vm.socket.on('connect_error', async error => {
        console.error('[connect error]: ', error)
        await vm.$store.dispatch('loadLatestUsers', {
          type: vm.type
        })
      })
    })
  },
  destroyed() {
    const vm = this
    vm.socket.disconnect()
  },
  methods: {
    onUserScroll: async function() {
      var vm = this
      if (vm.isMobile) {
        return false
      }
      let messages = $('#users_' + vm.type)
      let scrollPosition = messages.scrollTop()
      let chatboxHeight = messages.outerHeight(true)
      let totalHeight = messages.prop('scrollHeight')

      if (scrollPosition <= chatboxHeight) {
        vm.enableAutoUpdate(true)
      }
      if (Math.abs(Math.round(scrollPosition + chatboxHeight) - totalHeight) < 3) {
        vm.enableAutoUpdate(false)
        await vm.onLoadmore()
      }
    },
    enableAutoUpdate: function(enable) {
      this.$set(this.$store.state.livechat.userlist[this.type], 'isAutoRefresh', enable)
    },
    onResizeUserList: function() {
      var vm = this
      vm.$nextTick(function() {
        if (document.getElementById('chattype')) {
          vm.userListHeight =
            window.innerHeight -
            document.getElementById('main_toolbar').clientHeight -
            document.getElementById('chattype').clientHeight -
            5
        }
      })
    },
    selectUser: async function(user) {
      const vm = this
      vm.$store.state.livechat.sessiontoken = user.sessiontoken
      let update_user = cloneDeep(user)
      update_user.type = update_user.context == 'contactadmin' ? 'admin' : 'bot'

      if (!vm.$aston.astonpages.includes(vm.$store.state.livechat.pageid)) {
        var data = {
          adminid: vm.$store.state.userid,
          pageid: vm.$store.state.livechat.pageid,
          app: update_user.app,
          context: update_user.context
        }
        if (update_user.userid || update_user.id) {
          data.userid = update_user.userid || update_user.id
          data.type = 'user'
        } else {
          data.userid = update_user.group_id
          data.type = 'group'
        }
        update_user.userid = data.userid
        try {
          const user = vm.$store.state.livechat.userlist[vm.type].users.filter(
            user => (user.userid || user.group_id) === data.userid
          )

          if (user.length > 0 && !user[0].adminread) {
            vm.adminreadchat(data)
            update_user.adminread = true
            user[0].adminread = true
          }
          vm.$store.state.livechat.users_unread[update_user.userid] = 0
        } catch (error) {}
      } else {
        update_user.userid = update_user.userid || update_user.id
      }
      vm.$store.commit('SET_LIVECHAT_USER', update_user)
      vm.$emit('onClickUser')
    },
    adminreadchat(data) {
      this.socket.emit('livechat:forward-adminreadchat', data, response => {
        /* Handle response, if any */
        console.error('[response]: ', response)
      })
      if (
        this.$store.state.countAllNotiCustom &&
        this.$store.state.countAllNotiCustom[this.$store.state.livechat.pageid] &&
        this.$store.state.countAllNotiCustom[this.$store.state.livechat.pageid] > 0
      ) {
        this.$store.state.countAllNotiCustom[this.$store.state.livechat.pageid] =
          this.$store.state.countAllNotiCustom[this.$store.state.livechat.pageid] - 1
        this.$store.state.livechat.users_unread[this.$store.state.livechat.pageid][data.userid] = 0
        this.$emit('update:timestamp', dayjs().format('x'))
      }

      if (
        this.newchatnotify[
          `${data.app}_${data.type === 'group' ? 'group_' : ''}${
            data.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] > 0
      ) {
        this.newchatnotify[
          `${data.app}_${data.type === 'group' ? 'group_' : ''}${
            data.context === 'contactadmin' ? 'admin' : 'bot'
          }`
        ] =
          this.newchatnotify[
            `${data.app}_${data.type === 'group' ? 'group_' : ''}${
              data.context === 'contactadmin' ? 'admin' : 'bot'
            }`
          ] - 1
      }
      return new Promise((resolve, reject) => {
        api.adminreadchat(data, (error, response) => {
          if (error) reject(error)

          resolve(response)
        })
      })
    },
    getLatestChatUsers: function() {
      var vm = this
      if (vm.loading) {
        return false
      }
      let limit = 20
      if (vm.livechatUsers(vm.type).length == 0) {
        limit = 20
      }

      vm.getLiveChatUsers(0, limit, true).then(
        function(users) {
          vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: users })
        },
        function(error) {
          // console.log(error)
        }
      )
    },
    getLiveChatUsers: function(offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        vm.loading = true
        let data = {
          pageid: vm.$store.state.livechat.pageid,
          offset: offset,
          limit: limit,
          inbox: vm.type,
          app: vm.app,
          line_tab: vm.app === 'line' ? vm.line_tab : 'user'
        }

        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.uu_areaname = vm.selectedBot.uu_areaname
          } else if (vm.filter.uuAreaName != '') {
            data.uu_areaname = vm.filter.uuAreaName
          }
          if (vm.filter.lineid) {
            data.lineid = vm.filter.lineid
          }
          if (vm.filter.uu_register_status) {
            data.uu_register_status = vm.filter.uu_register_status
          }
          if (vm.filter.lastconversationfrom) {
            data.lastconversationfrom = vm.filter.lastconversationfrom
          }
          if (vm.filter.lastconversationto) {
            data.lastconversationto = vm.filter.lastconversationto
          }
        }
        api.getLiveChatUsers(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.loading = false
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    matchChatboxHeight: function() {
      let vm = this
      let totalHeight = vm.windowHeight
      let headerHeight = $('header').outerHeight(true)
      let typeHeight = $('#chattype').outerHeight(true)
      totalHeight = totalHeight - headerHeight - typeHeight
      $('.users').height(totalHeight)
    },
    onLoadmore: async function() {
      const vm = this
      if (vm.loadmore || !vm.$store.state.livechat.userlist[vm.type].hasMore) {
        return false
      }
      // vm.loadmore = true
      vm.$store.commit('SET_LIVECHAT_LOADMORE', true)

      vm.$set(
        vm.$store.state.livechat.userlist[vm.type],
        'offset',
        vm.$store.state.livechat.userlist[vm.type].offset + vm.$store.state.livechat.limitFatchUser
      )

      try {
        await vm.$store.dispatch('loadMoreLivechatUsers', {
          type: vm.type
        })
      } catch (error) {}
      vm.$store.commit('SET_LIVECHAT_LOADMORE', false)
    }
  },
  watch: {
    searchlist(newVal, oldVal) {
      if (newVal != oldVal) {
        this.onResizeUserList()
      }
    },
    line_tab: async function(newVal, oldVal) {
      const vm = this
      if (newVal != oldVal) {
        vm.$set(vm.$store.state.livechat, 'line_tab', newVal)
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    type: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.dispatch('updateLivechatUsers', { type: this.type, users: [] })
        this.userloading = true
        try {
          await this.$store.dispatch('loadLivechatUsers', {
            type: this.type
          })
          this.userloading = false
        } catch (error) {}
      }
    },
    app: async function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.onResizeUserList()
        vm.$set(vm.$store.state.livechat, 'app', newVal)
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    selectedBot: async function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {}
      }
    }
  },
  beforeDestroy: function() {
    const vm = this
    // For a specific event
    vm.socket.removeAllListeners(['eventName'])
    // For all events
    vm.socket.removeAllListeners()
    // Disconnect socket
    vm.socket.disconnect()
    clearInterval(vm.timer)
  }
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #c6c6c6;
  }

  &:active {
    background: rgb(245, 244, 244);
  }
}
.user .unreadmessage:not(.active) {
  background-color: #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-users.vue